export default __webpack_public_path__ + "static/media/5.2e95c4b2.png";